import { Box, Button, useDisclosure } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { useState, useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";

import ProductList from "./ProductList";
import AddProduct from "./AddProduct";

const ProductContainer = () => {
  const [showProductList, setShowProductList] = useState(true);
  const [editingProduct, setEditingProduct] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();

  const handleAddProduct = () => {
    setEditingProduct(null);
    setShowProductList(false);
  };

  const handleEdit = (rowData) => {
    console.log("Edit clicked for:", rowData);
    setEditingProduct(rowData);
    setShowProductList(false);
  };

  const handleBack = () => {
    setEditingProduct(null);
    setShowProductList(true);
  };

  const handleDelete = (rowData) => {
    console.log("Delete clicked for:", rowData);
    setSelectedProduct(rowData);
    onOpen();
  };

  const confirmDelete = () => {
    console.log("Deleted:", selectedProduct);
    onClose(); // Close modal after deleting
  };

  return (
    <>
      {showProductList ? (
        <ProductList handleAddClient={handleAddProduct} handleEdit={handleEdit} handleDelete={handleDelete} />
      ) : (
        <>
         
          <AddProduct productData={editingProduct} />
        </>
      )}

      {/* Delete Confirmation Modal */}
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Archive
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure you want to archive this product.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={confirmDelete} ml={3}>
                Yes, Archive
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default ProductContainer;
